exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6a55c614] .el-card__body{height:100%}.successTextColor[data-v-6a55c614]{color:var(--tagSuccessText)}.infoText[data-v-6a55c614]{color:var(--tagInfoText)}", ""]);

// exports
